<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';

defineProps({
  isSelected: Boolean,
});
</script>

<template>
  <KBtn
    :class="$style.paginationBtn"
    size="xs"
    :variant="isSelected ? 'flat' : 'outlined'"
    data-testid="paginationBtn"
  >
    <slot></slot>
  </KBtn>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.paginationBtn {
  height: 32px !important;
  padding: 0 5px;
  min-width: 32px;

  :global {
    .v-btn__overlay {
      background-color: transparent;
    }
  }
}
</style>
